import React, { Component } from 'react';
import PropTypes from "prop-types";
import axios from "axios";

import Button from "../../../../components/UI/Button";
import ModalOverlay from "../../../../components/UI/ModalOverlay";
import theme from '../../../../Theme/theme';
import Spinner from '../../../../components/LoadingSpinner';
import SearchBox from "../../../../components/SearchBox";
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from "config/constants";

const SEARCH_TEXT = "Search by gym name"
const NO_GYM_FOUND = "No Gyms found"
const NO_OVERRIDE_GYM = "No gyms are affected by this override"
const buttonList = {
    NONE_SELECTED: 0,
    INDIVIDUAL_GYM_BUTTON: 1,
    SAVE_STANDARD_BUTTON: 2,
    OVERRIDE_ALL_BUTTON: 3,
    SAVE_OVERRIDE_BUTTON: 4
}

class GymListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gymsList: {},
            filteredGyms: [],
            isLoading: true
        }
    }

    componentDidMount() {
        if (this.props.buttonSelected === buttonList.OVERRIDE_ALL_BUTTON) {
            this.getOverridingGyms()
        } else {
            this.props.gymsList.length > 0 ?
                this.setState({ gymsList: this.props.gymsList, filteredGyms: this.props.gymsList, isLoading: false }) : this.getGymsList();
        }
    }

    getGymsList() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/admin/gyms`, {
                headers: {
                    "x-access-token": access_token
                }
            }).then(res => {
                if (!res.error) {
                    this.setState({
                        gymsList: res.data,
                        filteredGyms: res.data
                    }, () => {
                        this.props.updateGymsList(this.state.gymsList);
                        this.getGymTags();
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                    this.setState({ isLoading: false })
                }
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    getOverridingGyms() {
        const access_token = localStorage.getItem("access_token");
        axios
            .post(`${API_URL}/admin/discounts/overridingGyms`, {
                updatedDiscount: this.props.updatedDiscount
            }, {
                headers: {
                    "x-access-token": access_token
                }
            }
            ).then(res => {
                if (!res.error) {
                    this.setState({
                        gymsList: res.data,
                        filteredGyms: res.data
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    //This method gets called only if the gym tags list is available
    updateGymListWithGymTags(data) {
        let gymTagList = []
        data.forEach((gymTag) => {
            gymTagList.push({ gym_id: gymTag.id + GYM_TAG_UNIQUE_ID, gym_name: gymTag.name })
        })
        return gymTagList
    }

    getGymTags() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/tags`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                if (!res.error && res.data) {
                    let updateGymList = this.updateGymListWithGymTags(res.data);
                    updateGymList.push(...this.state.gymsList);
                    this.setState({
                        gymsList: updateGymList,
                        filteredGyms: updateGymList
                    }, () => {
                        this.props.updateGymsList(this.state.gymsList)
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    renderSearchGymsButton = () => {
        return (
            <div style={style.searchGymContainer}>
                <SearchBox
                    hideSearchImage={true}
                    placeholder={SEARCH_TEXT}
                    searchWrapperStyle={style.searchWrapper}
                    searchInputStyle={style.searchInput}
                    onChange={(e) => this.searchHandler(e)}>
                </SearchBox>
            </div>
        );
    }

    renderGymList() {
        return (
            this.state.filteredGyms.length > 0 ? <div style={style.container}>
                {this.state.filteredGyms.map((gym, index) => {
                    const city = gym.address && gym.address.includes(",") > 0 ? ", " + gym.address.split(",")[1] : ""
                    const gymContainerStyle = gym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? { ...style.gymNameContainer, ...{ background: theme.color.lightGreen } } : style.gymNameContainer
                    return (
                        gym.gym_name && <div key={"gymListContainer" + gym.gym_id} style={gymContainerStyle} onClick={() => this.props.buttonSelected === buttonList.INDIVIDUAL_GYM_BUTTON && this.props.updateSelectedGym(gym)}>
                            <div key={"gymListName" + gym.gym_id} style={style.gymName}>{gym.gym_name}{city}</div>
                        </div>
                    )
                })}
            </div> : <div style={{ ...style.container, ...style.alertContainer }}> {this.props.buttonSelected === buttonList.OVERRIDE_ALL_BUTTON ? NO_OVERRIDE_GYM : NO_GYM_FOUND}</div>
        )
    }

    searchHandler = (e) => {
        const filteredGyms = this.state.gymsList.filter(gym => {
            const gymName = gym.gym_name;
            return gym.gym_name && gymName.toLowerCase().includes(e.target.value.toLowerCase())
        })
        this.setState({ filteredGyms })
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                <ModalOverlay
                    modalStyle={style.modalStyle}
                    header="Gym List"
                    headerStyle={style.headerStyle}
                    headerBodyStyle={style.headerBodyStyle}
                    bodyStyle={style.modalBody}
                    underLayerStyle={style.underLayer}
                    close={this.props.close}
                >
                    <div>
                        {this.renderSearchGymsButton()}
                        {this.renderGymList()}
                        <Button style={style.button} type="primary" onClick={this.props.buttonAction}>{this.props.buttonTitle.toUpperCase()}</Button>
                    </div>
                </ModalOverlay>
        )
    }
}

GymListModal.propTypes = {
    gymsList: PropTypes.array.isRequired,
    updateGymsList: PropTypes.func.isRequired,
    updateSelectedGym: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    buttonAction: PropTypes.func.isRequired,
    buttonTitle: PropTypes.string.isRequired,
    buttonSelected: PropTypes.any.isRequired,
    updatedDiscount: PropTypes.object.isRequired
};

const style = {
    container: {
        display: 'flex',
        width: 500,
        height: 350,
        overflowY: "auto",
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.color.white,
        borderRadius: 3,
        marginBottom: 8
    },
    modalStyle: {
        backgroundColor: theme.color.transparent
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        height: 60,
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        backgroundColor: theme.color.red,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.textLightWhite,
    },
    modalBody: {
        width: "100%",
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    button: {
        width: "100%",
        height: 60,
        fontSize: 31,
        letterSpacing: 0,
        lineHeight: "60px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.textLightWhite,
        backgroundColor: theme.color.primaryPink,
        borderRadius: 5,
        borderWidth: 0
    },
    gymNameContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 60,
        width: "100%",
        backgroundColor: theme.color.white,
        borderBottom: "2px solid " + theme.color.tableSeparatorGrey
    },
    gymName: {
        fontSize: 17,
        width: "90%",
        verticalAlign: "middle",
        textAlign: "center",
        letterSpacing: 0,
        lineHeight: "60px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey
    },
    alertContainer: {
        height: 150,
        justifyContent: "center",
        fontSize: 26,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        background: theme.color.white
    },
    searchGymContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        lineHeight: "60px",
        backgroundColor: theme.color.white
    },
    searchWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        width: "90%",
        position: "relative"
    },
    searchInput: {
        backgroundColor: theme.color.lightGrey,
        borderRadius: 32,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: theme.color.white,
        fontSize: 20,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.searchTextGrey,
        width: "100%",
        paddingLeft: 20,
        textAlign: "left"
    }
};

export default GymListModal;

